(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/kung-keno-toggle.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/kung-keno-toggle.js');

'use strict';

let hasShownKungKenoDialog = false;
svs.numbergames.game.views.KungKenoToggle = Marionette.View.extend({
  ui: {
    kungKenoToggle: '.js-kung-keno-toggle'
  },
  triggers: {
    'change @ui.kungKenoToggle': 'changeKungKeno'
  },
  modelEvents: {
    'change:hasKungKeno': 'onChangeHasKungKeno',
    cleared: 'render'
  },
  className() {
    return "numbergames-kung-keno-toggle numbergames-kung-keno-toggle-keno js-numbergames-kung-keno-toggle";
  },
  template(data) {
    return svs.numbergames.game.templates.kung_keno_toggle(data);
  },
  onChangeKungKeno(view, event) {
    this.model.set({
      hasKungKeno: event.target.checked
    });
  },
  onChangeHasKungKeno(view, hasKungKeno) {
    if (hasKungKeno || hasShownKungKenoDialog) return;
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo: this.getUI('kungKenoToggle'),
      title: 'Du spelar utan Kung Keno!',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text: 'Välj Kung Keno om du vill få chans på de högsta vinsterna - dessutom blir det alltid vinst om du prickar in Kung Keno-numret på din rad.'
      }]
    }));
    hasShownKungKenoDialog = true;
  }
});

 })(window);